<template>
<CRow>
    <CCol col="12" sm="9" class="mx-auto" v-if="step === 0">
        <CRow>
            <CCol col="12" class="mb-2">
                <label class="d-block mb-0 font-lg">
                    {{ $t('campaign.settings._')+' '+$t('campaign.plan') }}
                </label>
            </CCol>

            <PlanSettingsForm @submit="updatePlanSettings" :settings="$deepClone(campaign.plan.settings)" :planKey="campaign.plan.key" :goal="campaign.goal" />
        </CRow>
    </CCol>

    <CCol col="12" sm="9" class="mx-auto" v-if="step === 1">
        <CRow>
            <CCol col="12">
                <BackBtn @click="backToPlanSettings()" />
            </CCol>

            <CCol col="12" class="mb-2">
                <label class="d-block mb-0 font-lg">
                    {{ $t('campaign.settings._')+' '+$t('campaign._') }}
                </label>
            </CCol>

            <CCol col="12">
                <CampaignInfoForm @submit="updateCampaignInfo" :campaign="campaign" />
            </CCol>
        </CRow>
    </CCol>
</CRow>
</template>

<script>
import PlanSettingsForm from './PlanSettingsForm'
import CampaignInfoForm from './CampaignInfoForm'
import { campaignGoalOption, campaignPlanOption } from '@/common/data'
import { planStr, goalStr, emailTypeStr, instagramAdTypeStr } from './methods'
import { CampaignPlan, CampaignGoal } from '@/constants'

export default {
    name: 'EditForm',

    components: {
        PlanSettingsForm,
        CampaignInfoForm
    },

    props: {
        submit: {
            required: true,
            type: Function,
            default() {}
        },
        campaign: {
            default() {
                return {
                    //
                }
            },
            type: Object
        }
    },

    data() {
        return {
            step:0 ,
            CampaignPlan,
            campaignGoalOption,
            campaignPlanOption,
        }
    },

    computed: {
        campaignCost() {
            const costSettings = this.campaignPlanOption.find(item => item.value === this.campaign.plan.key).cost
            const planSettings = this.campaign.plan.settings

            if ([CampaignGoal.ACTIVE_OLD_PUBLISHERS, CampaignGoal.NOTIFICATION].includes(this.campaign.goal)) {
                planSettings.max_send = 500
            }

            const costOfPlans = {
                [CampaignPlan.IN_APP]: (planSettings, costSettings) => Math.round(planSettings.max_send / costSettings.unit) * costSettings.price,
                [CampaignPlan.EMAIL]: (planSettings, costSettings) => Math.round(planSettings.max_send / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.SMS]: (planSettings, costSettings) => Math.round(planSettings.max_send / costSettings.unit) * costSettings.price,
                [CampaignPlan.BLOG_POST]: (planSettings, costSettings) => Math.round(planSettings.target_clicks / costSettings.unit) * costSettings.price,
                [CampaignPlan.REPORTAGE]: (planSettings, costSettings) => costSettings.unit * costSettings.price,
                [CampaignPlan.RETARGET]: (planSettings, costSettings) => Math.round(planSettings.period / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.TOP_STORE]: (planSettings, costSettings) =>Math.round(planSettings.period / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.STORE_OF_THE_WEEK]: (planSettings, costSettings) => Math.round(planSettings.period / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.AFFILI_TELEGRAM_CHANNEL]: (planSettings, costSettings) => costSettings.unit * costSettings.price,
                [CampaignPlan.AFFILI_INSTAGRAM_PAGE]: (planSettings, costSettings) => costSettings.unit * costSettings.price,
            }

            return costOfPlans[this.campaign.plan.key](planSettings, costSettings) // IRR
        },
    },

    methods: {
        planStr,
        goalStr,
        emailTypeStr,
        instagramAdTypeStr,
        updateCampaignInfo(campaignInfo) {
            this.campaign.name = campaignInfo.name
            this.campaign.description = campaignInfo.description

            this.submit()
        },
        updatePlanSettings(settings) {
            this.campaign.plan.settings = settings
            this.step = 1
        },
        backToPlanSettings() {
            this.step = 0
        }
    }
}
</script>